<template>
<div>
  <dropdown :is-active.sync="isActive" class="is-right user-dropdown">
    <a @click.prevent="toggleDropdown" v-click-outside="closeDropdown">
      <user-image size="is-40x40" />
    </a>
    <template slot="dropdown-content">
      <router-link class="dropdown-item" to="/me">{{$t("nav.profile")}}</router-link>
      <router-link class="dropdown-item" to="/settings">{{$t("nav.settings")}}</router-link>
      <a class="dropdown-item" @click.prevent="onLogout">{{$t('nav.logout')}}</a>
    </template>
  </dropdown>
  <div class="mobile">
    <router-link class="dropdown-item" to="/me">{{$t("nav.profile")}}</router-link>
    <router-link class="dropdown-item" to="/settings">{{$t("nav.settings")}}</router-link>
    <a class="dropdown-item" @click.prevent="onLogout">{{$t('nav.logout')}}</a>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Dropdown from '@/components/general/dropdown'
import UserImage from '@/components/general/user-image'
import ClickOutside from 'vue-click-outside'

export default {
  components: { Dropdown, UserImage },
  computed: {
    ...mapGetters('users', [
      'user'
    ])
  },
  methods: {
    toggleDropdown () {
      this.isActive = !this.isActive
    },
    closeDropdown () {
      this.isActive = false
    },
    ...mapActions('app', [
      'logout'
    ]),
    async onLogout () {
      await this.logout()
      this.$router.push('/login')
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.user-dropdown /deep/ .dropdown-menu {
  padding-top: 0.45rem;

  .dropdown-item.router-link-active {
    font-weight: bold;
    color: $black;
    &:hover {
      background-color: transparent;
    }
  }
}

.mobile {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;

  .dropdown-item {
    display: inline;
    line-height: 30px;
    padding: 20px;
    &:hover {
      background-color: transparent;
    }
  }
}

@media screen and (min-width: $tablet) {
  .mobile {
    display: none;
  }
}

@media screen and (max-width: $tablet) {
  .user-dropdown {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/user-dropdown.vue